import Vue from "vue";
import XEUtils from "xe-utils";
import { VXETable, Modal, Button } from "vxe-table";
import "vxe-table/lib/style.min.css";

import zhCN from "vxe-table/lib/locale/lang/zh-CN";

VXETable.setup({
  i18n(key) {
    return XEUtils.get(zhCN, key);
  }
});

Vue.use(Modal).use(Button);



// WEBPACK FOOTER //
// ./src/plugins/table.js